import { render, staticRenderFns } from "./InstagramContactList.vue?vue&type=template&id=29bc8857&scoped=true"
import script from "./InstagramContactList.vue?vue&type=script&lang=js"
export * from "./InstagramContactList.vue?vue&type=script&lang=js"
import style0 from "./InstagramContactList.vue?vue&type=style&index=0&id=29bc8857&prod&lang=scss"
import style1 from "./InstagramContactList.vue?vue&type=style&index=1&id=29bc8857&prod&scoped=true&lang=scss"
import style2 from "./InstagramContactList.vue?vue&type=style&index=2&id=29bc8857&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bc8857",
  null
  
)

export default component.exports